import { mergeClassName as e } from "../../utils/data.js";
import t from "./Calendar.module.js";
import { jsxDEV as n } from "react/jsx-dev-runtime";
import { CheckIcon as r } from "@phosphor-icons/react";
//#region lib/components/DatePicker/PresetsSidebar.tsx
var i = "/opt/render/project/src/shared-ui/lib/components/DatePicker/PresetsSidebar.tsx";
function a({ presets: a, activePresetId: o, onSelect: s, className: c }) {
	return /* @__PURE__ */ n("div", {
		className: e(t.presets, c),
		children: a.map((a) => {
			let c = a.id === o;
			return /* @__PURE__ */ n("button", {
				type: "button",
				className: e(t.presetItem, c && t.presetItemActive),
				onClick: () => {
					s(a);
				},
				children: [/* @__PURE__ */ n("span", { children: a.label }, void 0, !1, {
					fileName: i,
					lineNumber: 27,
					columnNumber: 25
				}, this), c && /* @__PURE__ */ n(r, {
					size: 16,
					className: t.presetCheck,
					"aria-hidden": !0
				}, void 0, !1, {
					fileName: i,
					lineNumber: 28,
					columnNumber: 36
				}, this)]
			}, a.id, !0, {
				fileName: i,
				lineNumber: 19,
				columnNumber: 21
			}, this);
		})
	}, void 0, !1, {
		fileName: i,
		lineNumber: 15,
		columnNumber: 9
	}, this);
}
//#endregion
export { a as PresetsSidebar };
